import { type PreviewSettings } from '../types';
import { type SoqlFilter } from 'common/components/FilterBar/SoqlFilter';

interface ReportingPeriodSettingsProps {
  dateFilters: SoqlFilter[];
  reportingPeriod?: string;
  onChange: <K extends keyof PreviewSettings>(key: K, value: PreviewSettings[K]) => void;
}

export const ReportingPeriodSettings = ({
  dateFilters,
  reportingPeriod,
  onChange,
}: ReportingPeriodSettingsProps) => {
  if (dateFilters.length === 0) {
    return null;
  }

  return (
    <div className="pdf-preview-modal__settings-group" data-testid="reporting-period-filter">
      <label>Reporting period</label>
      <select
        data-testid="reporting-period-filter-select"
        value={reportingPeriod || ''}
        onChange={(e) => onChange('reportingPeriod', e.target.value || undefined)}
      >
        <option value="">No filter selected</option>
        {dateFilters.map((filter, index) => {
          const displayText =
            filter.displayName || filter.columns[0]?.displayName || filter.columns[0]?.fieldName;
          return (
            <option key={filter.reactKey || index} value={filter.columns[0]?.fieldName}>
              {displayText}
            </option>
          );
        })}
      </select>
    </div>
  );
};
